import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function usePriceUnits() {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			time: t("priceTime", "Per produced minute"),
			fixed: t("priceFixed", "Fixed price"),
			hour: t("priceHour", "Per produced hour"),
			activity: t("priceActivity", "Per worked minute"),
			percentage: t("pricePercentage", "Percentage of costs"),
			year: t("priceYear", "Per year"),
		}),
		[t],
	);
}
